import React, { useState, useEffect , useContext } from 'react'
import { Container } from 'react-bootstrap'
import { IoMenu } from 'react-icons/io5'
import { AiOutlineUser } from 'react-icons/ai'
import { GoSearch } from 'react-icons/go'
import './NavbarResponsive.css'
import { useNavigate } from 'react-router-dom'
import SideBarComponent from '../SideBarComponent/SideBarComponent'
import { Link } from 'react-router-dom'
import { isLoggedIn } from '../../Hooks/isLoggedIn'
import { SearchContext } from '../../Hooks/useContext'
export default function NavbarResponsive() {
    const {searchValue , setSearchValue} = useContext(SearchContext)
    const [showSideBar, setShowSideBar] = useState(false)
    const [showSearchInput, setshowSearchInput] = useState(false)
    const ShowSideBarActiveHandler = () => { setShowSideBar(true) }

    const ShowSideBarCloseHandler = () => setShowSideBar(false)
    const handleShowSearchInput = () => setshowSearchInput(!showSearchInput)

    const Navigate = useNavigate()
    const handleSearch = () => {
        Navigate('/search/' + searchValue + '/all')

    }
    return (
        <div className='navbar-responsive'>
            <Container fluid='lg' className='navbar-responsive-container'>
                <div className='navbar-responsive-right' onClick={ShowSideBarActiveHandler}>
                    <IoMenu />
                </div>
                <div className='navbar-responsive-left'>
                    <div className='navbar-responsive-search'>
                        <input className={showSearchInput ? 'active' : ''} 
                        type="text" placeholder='جستجو کنید'
                         onChange={(e) => {
                            handleSearch()
                            setSearchValue(e.target.value)
                        }
                        }/>
                        <GoSearch onClick={handleShowSearchInput}/>

                    </div>
                    <div className='navbar-responsive-user'>
                        <Link to={isLoggedIn() ? '/userpanel' : '/login'}>
                            <AiOutlineUser />
                        </Link>
                    </div>
                </div>
            </Container>
            <SideBarComponent showSideBar={showSideBar} ShowSideBarCloseHandler={ShowSideBarCloseHandler} />
        </div>
    )
}
